"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/TabComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TabItemComponent = /** @class */ (function (_super) {
    __extends(TabItemComponent, _super);
    function TabItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabItemComponent.prototype.render = function () {
        return react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement("div", { className: "card-header collapsed", id: "heading_" + this.props.UniqueKey, "data-toggle": "collapse", "data-parent": "#TabContent2_" + this.props.ParentUniqueKey, "aria-expanded": "false", "aria-controls": "collapse_" + this.props.UniqueKey },
                react_1.default.createElement("a", { "data-parent": "#TabContent2_" + this.props.ParentUniqueKey, className: "collapsed", "data-toggle": "collapse", href: "#collapse_" + this.props.UniqueKey, "aria-expanded": "false", "aria-controls": "collapse_" + this.props.UniqueKey },
                    react_1.default.createElement("h5", { className: "mb-0" },
                        this.props.Title,
                        react_1.default.createElement("i", { className: "fas fa-plus rotate-icon" })))),
            react_1.default.createElement("div", { id: "collapse_" + this.props.UniqueKey, className: "collapse", role: "tabpanel", "aria-labelledby": "heading_" + this.props.UniqueKey, "data-parent": "#TabContent2_" + this.props.ParentUniqueKey },
                react_1.default.createElement("div", { className: "card-body" },
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.Content } }),
                    react_1.default.createElement("div", { className: "notes-separator" },
                        react_1.default.createElement("p", null, this.props.Note)))));
    };
    return TabItemComponent;
}(react_1.default.Component));
exports.default = TabItemComponent;
